import { render, staticRenderFns } from "./TPane.vue?vue&type=template&id=b7ebb6e6&scoped=true&"
import script from "./TPane.vue?vue&type=script&lang=js&"
export * from "./TPane.vue?vue&type=script&lang=js&"
import style0 from "./TPane.vue?vue&type=style&index=0&id=b7ebb6e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ebb6e6",
  null
  
)

/* custom blocks */
import block0 from "./TPane.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports